import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesTableViews from 'components/organisms/TableViews/EntitiesTableViews/EntitiesTableViews';

const StyledCollectionEntitiesTableViews = styled(EntitiesTableViews)`
  ${ComponentStyles}
`;

StyledCollectionEntitiesTableViews.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionEntitiesTableViews;
